export const name = 'viewerManagerTpaApi' as const
export const TpaCompPreviewDataSymbol = Symbol('TpaCompPreviewData')
